export default __webpack_public_path__ + "static/jenkins-efebceb7cd9bc8597392f99b7d90cc20.svg";